export const backendUrl = (process.env.VUE_APP_BACKEND_URL) ? process.env.VUE_APP_BACKEND_URL
  : 'http://localhost:8001'
export const frontendUrl = (process.env.VUE_APP_FRONTEND_URL) ? process.env.VUE_APP_FRONTEND_URL
  : 'http://localhost:8080'
export const ssoUrl = (process.env.VUE_APP_SSO_URL) ? process.env.VUE_APP_SSO_URL
  : 'https://sso.d.pusilkom.com'
export const siteKey = (process.env.VUE_APP_SITEKEY)
  ? process.env.VUE_APP_SITEKEY : ''
export const clientId = (process.env.VUE_APP_CLIENT_ID)
  ? process.env.VUE_APP_CLIENT_ID : ''
export const clientSecret = (process.env.VUE_APP_CLIENT_SECRET)
  ? process.env.VUE_APP_CLIENT_SECRET : ''
